import type { ApiClient } from "@/clients/ApiClient";

export interface SearchApi {
    /** Podcasts and episodes that match the query, best first */
    find(query: string): Promise<{ podcasts: Podcast[]; episodes: Episode[] }>;
}

/** How many of each the search view needs; both APIs cap this at 50 */
const RESULTS_PER_GROUP = 20;

interface SearchBody {
    results?: { podcasts?: Podcast[]; episodes?: Episode[] };
}

// One request answers both groups, and both APIs build the body alike: grouped under `results`,
// with a `relevance_score` on every hit. It is not wrapped in the Go API's `{data, cached}`.
export const createSearchApi = (client: ApiClient): SearchApi => ({
    async find(query) {
        const body = await client.get<SearchBody>(
            `/search?q=${encodeURIComponent(query)}&types=podcast,episode&limit=${RESULTS_PER_GROUP}`
        );
        return {
            podcasts: body?.results?.podcasts ?? [],
            episodes: body?.results?.episodes ?? [],
        };
    },
});
